import React, { useRef, useState, useEffect } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner';
import { Plus, X } from "react-bootstrap-icons";
import { addNewProductRequestComment, getProductRequestComments, setRequestCommentsPopup } from "../../store/api/ProductRequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation, faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';


const ModalRequestComments = (props) => {
    const comment = useRef();
    const [commentIsEmpty, setCommentEmpty] = useState(false);
    const commentList = useSelector(state => state.ProductRequestReducer.productRequestComments);
    const [commentsCount, setCommentCount] = useState(commentList ? commentList.length : 0);
    const requestMessagesPopup = useSelector(state => state.ProductRequestReducer?.requestMessagesPopup);

    const add2CommentList = () => {
        const cm = comment.current.value;
        if (!cm || cm === '') {
            setCommentEmpty(true);
            return;
        }
        else {
            setCommentEmpty(false);
        }
        const onSuccess = (item) => {
            commentList.push(item);
            setCommentCount(commentsCount + 1);
        }
        dispatch(addNewProductRequestComment(props.requestID, cm, onSuccess));
    }
    const dispatch = useDispatch();
    useEffect(() => {
        if (requestMessagesPopup.status === "show") {
            dispatch(getProductRequestComments(props.requestID));
        }
    }, [requestMessagesPopup.status]);
    const handleModal = () => {
        dispatch(setRequestCommentsPopup({ status: 'hide' }));
    }
    return (
        <Modal className="superwide-dialog" show={requestMessagesPopup.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faExclamationCircle} size='lg' />&nbsp;
                    ملاحظات درخواست
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={handleModal} /></Modal.Header>
            <Modal.Body className='bodyStyle'>
                <input type='hidden' value={commentsCount} readOnly />
                <div className='row'>
                    <div className='form-group'>
                        <label>متن ملاحظه</label>
                        <div>
                            <input type="text" className='form-control' ref={comment} style={{ width: window.innerWidth >= 414 ? "95%" : "86%", display: "inline-block" }} />
                            <button type="button" className='btn btn-block btn-primary group-Btn-smalll' onClick={add2CommentList}><Plus size={20} /></button>
                        </div>
                        {commentIsEmpty && <small className="errors">متنی وارد نشده است</small>}
                    </div>
                </div>
                <Table responsive={true} className='mt-1'>
                    <thead>
                        <tr style={{ padding: "0" }}>
                            <th style={{ width: "75px" }}>تاریخ ثبت</th>
                            <th style={{ width: "80px" }}>ثبت کننده </th>
                            {window.innerWidth >= 414 && <th style={{ width: "150px" }}>تکنسین/نماینده</th>}
                            <th>متن پیام</th>
                        </tr>
                    </thead>
                    <tbody>
                        {commentList && commentList === "PENDING" &&
                            <tr>
                                <td colSpan={5}>
                                    <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={25} width={25} />
                                </td>
                            </tr>
                        }
                        {commentList && Array.isArray(commentList) && commentList.map((item, i) => {
                            return (
                                <tr className='resultTableRow' key={i}>
                                    <td>{item.PCreateDate}</td>
                                    <td>{item.CreateByName}</td>
                                    {window.innerWidth >= 414 && <td>{item.ClientName}</td>}
                                    <td>{item.CommentBody}</td>
                                </tr>)
                        })
                        }
                    </tbody>
                </Table>
            </Modal.Body >
        </Modal >
    )
}
export default ModalRequestComments;